/** In this file we declare the name from the constants in each respectively ModuleDefinition  */

export default {
  ENTITY: {
    EMAIL_TEMPLATE: {
      name: "emailTemplate",
      TEMPLATE_TYPES: { CUSTOM: "CUSTOM", DEFAULT: "DEFAULT" },
      TYPES: {
        BACKEND_ERROR: "BACKEND_ERROR",
        RESERVATION_FAILURE: "RESERVATION_FAILURE",
        RESERVATION_STATUS_ORANGE: "RESERVATION_STATUS_ORANGE",
        RESERVATION_CONFIRMATION: "RESERVATION_CONFIRMATION",
        RESERVATION_STATUS_RED: "RESERVATION_STATUS_RED",
        GIFT_CARD: "GIFT_CARD",
        PURCHASE_EVENT: "PURCHASE_EVENT",
        PRE_STAY: "PRE_STAY",
        POST_STAY: "POST_STAY",
        CART_ABANDONMENT: "CART_ABANDONMENT",
      },
      CHRONO_UNITS: {
        SECONDS: "SECONDS",
        MINUTES: "MINUTES",
        HOURS: "HOURS",
        DAYS: "DAYS",
      },
      DESTINATION_TYPES: {
        PROPERTY: "PROPERTY",
        GUEST: "GUEST",
        ALL: "ALL",
      },
      GUEST_TYPES: {
        LOYALTY_GUEST: "LOYALTY_GUEST",
        NON_LOYALTY_GUEST: "NON_LOYALTY_GUEST",
        ALL: "ALL",
      },
    },
    LEGAL_INFO: {
      name: "legalInfo",
    },
    MODIFICATION: {
      name: "modification",
    },
    CANCELLATIONPOLICY: {
      name: "cancellationPolicy",
    },
    CANCELLATIONPOLICYCONFIGURATION: {
      name: "cancellationPolicyConfiguration",
    },
    PROMOTIONSBOOKINGWINDOW: {
      name: "promotionsBookingWindow",
    },
    QUESTIONNAIRE: {
      name: "questionnaire",
    },
    NESTEDQUESTIONNAIRE: {
      name: "nestedQuestionnaire",
    },
    DISPLAY: {
      name: "display",
    },
    PAYMENT_TYPES: {
      name: "paymentTypes",
    },
    FILTER: {
      name: "filter",
    },
    NESTEDFILTER: {
      name: "filterOptions",
    },
    EXTRAS: {
      name: "extras",
    },
    CONDITIONS: {
      name: "conditions",
    },
    CHANNEL_RESERVATION_LOG: {
      name: "channelReservationLog",
    },
    CONFIGURATION_MANAGER: {
      name: "configurationManager",
    },
    PROMOTIONS: {
      name: "promotions",
    },
    BOOKABLE: {
      name: "bookable",
    },
    CLIENTS: {
      name: "clients",
    },
    CONTRACTS: {
      name: "contracts",
    },
    PARTNERS: {
      name: "partners",
    },
    PROPERTIES: {
      name: "properties",
    },
    SERVICES: {
      name: "services",
    },
    FORWARDING_RESERVATIONS: {
      name: "forwardReservationsToChannels",
    },
    CART_ABANDONMENT: {
      defaultDelay: 60,
    },
  },
};
